import React, { useRef, useState } from 'react';
import { toggleContrast } from "extra/theme";
import useWindowClick from "hooks/useWindowClick";

import FontSizeSwitcher from "components/general/FontSizeSwitcher";

import { ContrastIcon, AccessibilityIcon } from "svg/icons";
import { SignLanguage } from "svg/web";
import { useTranslate } from 'context/LanguageContext';

const actions = [
	{
		key: "sign",
		target: "_blank",
		href: "https://tlumacz.um.gdynia.pl/",
		svg: <SignLanguage/>,
		title: "sign_language_interpreter"
	},
	{ 
		key: "contrast",
		href: "#",
		svg: <ContrastIcon/>, 
		title: "high_contrast", 
		onClick: e => {
			e.preventDefault(); 
			toggleContrast();
		}
	}
]

export default function HeaderAccessibility() {
	
	const translate = useTranslate();
	const main_box_ref = useRef();
	const [ show, setShow ] = useState( false );

	useWindowClick( e => {
		!main_box_ref.current.contains( e.target ) && setShow( false );
	});

	return (
		<div ref={ main_box_ref } className="header__accessibility">
			
			<div 
				className="header__accessibility_btn"
				onClick={() => setShow( !show )}	
			> 
				<AccessibilityIcon/>
				<span> { translate( "accessibility" )} </span>
			</div>

			{ show && 
				<div className="header__accessibility_box">
					{ actions.map( item => (
						<div key={ item.key } className="df-ac">
							<a {...item } title={ translate( item.title )}>
								{ item.svg }
							</a>

							<span> { translate( item.title )} </span>
						</div> 
					)) }

					<FontSizeSwitcher />
				</div>
			}
		</div>
	)
}

